module.exports = __webpack_public_path__ + "media/images/admin/icons/zap-266beaf136b6db26a96bb65a771bfec4.svg";